(function($) {
    
    const html = document.querySelector('html')
	const menu = html.querySelector('.user-dashboard .menu')
    const dashboardMenuButton = html.querySelector('.user-dashboard .menu .toggle-menu')
    
    if(menu && dashboardMenuButton) {
        dashboardMenuButton.addEventListener('click', () => {
            
            menu.classList.toggle('open')
            html.classList.toggle('no-scroll')
            dashboardMenuButton.classList.toggle('open')
            dashboardMenuButton.setAttribute('aria-label', menu.classList.contains('open') ? 'Fechar menu' : 'Abrir menu')
        })
    }
    
})(jQuery);
(function($) {
  
    $(window).on('load', function () {
      
        $('footer .menu-item-has-children').each(function(el) {
            function openSubmenu(element) {
                element.find('a[href="#"]').addClass('open')
                
                const submenu = element.find('.menu')
                const submenuHeight = submenu[0].scrollHeight
                
                submenu.height(submenuHeight)
            }
            
            function closeSubmenu(element) {
                element.find('a[href="#"]').removeClass('open')
                element.find('a[href="#"').attr('data-submenu', null)
                
                const submenu = element.find('.menu')
                
                submenu.attr('style', null)
            }
            
            $(this).find('> a').on('click', event => {
                const mainLink = $(this).find('a[href="#"]')
                
                if(mainLink) {
                    event.preventDefault()
                    $(this).find('.menu').css('height') == '0px' 
                        ? openSubmenu($(this)) 
                        : closeSubmenu($(this))
                }
            })
            
            $(this).find('> a').on('mouseenter', () => {
                openSubmenu($(this))
            })
            
            $(this).find('.menu').on('mouseenter', () => {
                openSubmenu($(this))
            })
            
            $(this).find('> a').on('mouseleave', () => {
                closeSubmenu($(this))
            })
            
            $(this).find('.menu').on('mouseleave', () => {
                closeSubmenu($(this))
            })
        })
    
    });

})(jQuery);
(function($) {
    
    // Galeria
    const galeriaSlider = $('.template-laboratorio .galeria .slider-container');
	
	if (galeriaSlider.length) {
		
		galeriaSlider.each(function(index, element) {
			const container = $(element)
			const slider = container.find('.slider-wrapper')
			const prevArrow = container.find('.prev')
			const nextArrow = container.find('.next')
			
			slider.slick({
			    accessibility: false,
				slidesToShow: 4,
                centerMode: true,
				infinite: true,
				dots: false,
				arrows: true,
				draggable: false,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [
					{
						breakpoint: 993,
						settings: {
							slidesToShow: 3,
							dots: false,
						}
					},
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							dots: false,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							draggable: true,
							centerMode: false,
							arrows: false,
							dots: true,
							appendDots: container
						}
					}
				]
			})
		})
	}
})(jQuery);
(function($) {
    // Menu
    function menuToggle(e) {
        $('.mobile-menu-button').toggleClass('open');
        $('.main-navbar').toggleClass('open');
        $('body').toggleClass('no-scroll');
    }
    $('.mobile-menu-button').on('click', menuToggle);
    
    function submenuToggle(e) {
      e.preventDefault()
      
      if ($(this).attr('href') != "#" && screen.width > 1200) {  
        window.location.replace($(this).attr('href'));
      }
      
      $(this).parent().toggleClass('active');
      
      let submenu = $(this).next('ul');
      
      if ($(this).parent().hasClass('active') && submenu.length) {
        submenu.height( submenu.prop("scrollHeight") );
      } else {
        submenu.height( 0 );
      }
    }
    $('.main-navbar .menu-item-has-children > a').on('click tap', submenuToggle);
    
    function closeMenuOnClick(event) {
      if(!$(event.target).parent().hasClass('menu-item-has-children')) {
        menuToggle();
      }
    }
    $('.main-navbar a').on('click', function(e) {
      if(window.matchMedia('(max-width: 1200px)').matches) {
        closeMenuOnClick(e)
        return
      }
    })
    $('footer a[href="#"]').on('click', function(e) {
      e.preventDefault();
    });
  
})(jQuery);
(function($) {
  
  $(window).on('load', function () {})

})(jQuery);
(function($) {
    
    // Mapa
    const mapa = document.querySelectorAll('.dl-map')
    
    if(mapa && window.unidades) {
        mapa.forEach(el => {
            const features = []
            
            let xCoordinates = []
            let yCoordinates = []
            
            for(let pin of window.unidades) {
                const feature = new ol.Feature({
                    geometry: new ol.geom.Point(ol.proj.fromLonLat([pin.eixo_y, pin.eixo_x]))
                })
                
                xCoordinates.push(pin.eixo_x)
                yCoordinates.push(pin.eixo_y)
                features.push(feature)
            }
            
            let maxX = Math.max(...xCoordinates)
            let minX = Math.min(...xCoordinates)
            let maxY = Math.max(...yCoordinates)
            let minY = Math.min(...yCoordinates)
            
            const averageX = (maxX + minX) / 2
            const averageY = (maxY + minY) / 2
            
            new ol.Map({
                target: el,
                controls: ol.control.defaults({ attribution: false }),
                interactions: ol.interaction.defaults({mouseWheelZoom: false}),
                layers: [
                    new ol.layer.Tile({
                        title: 'Laboratório Veterinário Pró Vita',
                        className: 'bw',
                        source: new ol.source.OSM()
                    }),
                    new ol.layer.Vector({
                        source: new ol.source.Vector({
                            className: 'icon',
                            features: features
                        }),
                        style: new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: [0.5, 1],
                                anchorXUnits: 'fraction',
                                anchorYUnits: 'fraction',
                                scale: 0.5,
                                src: el.dataset.markers
                            })
                        })
                    }),
                ],
                view: new ol.View({
                    center: ol.proj.fromLonLat([averageY, averageX]),
                    zoom: 8
                })
            });
        })
    }
    
})(jQuery);
(function($) {
  
    const workvetForm = document.querySelectorAll('.workvet-form')
    
    if(workvetForm) {
        workvetForm.forEach(el => {
            const form = el
            const selectCidade = form.querySelector('#select-cidade')
            
            if(form) {
                form.addEventListener('submit', event => {
                    const loginField = form.querySelector('input[name="tbCodigo"]')
                    
                    if(loginField) {
                        loginField.value = loginField.value.toUpperCase()
                    }
                })
            }
            
            if(selectCidade) {
                selectCidade.addEventListener('change', event => {
                    const currentTarget = event.currentTarget
                    const value = currentTarget.value ? currentTarget.value : null
                    
                    if(value) {
                        form.setAttribute('action', value)
                    }
                })
            }
        })
    }

})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				updateSentTime(form)
				
				const submitButton = this.querySelector('button[type=submit]')
				
				if(submitButton) {
					submitButton.classList.add('loading')
					submitButton.setAttribute('disabled', true)
				}
			})
			
			form.addEventListener('wpcf7submit', function() {
				const submitButton = this.querySelector('button[type=submit]')
				
				if(submitButton) {
					submitButton.classList.remove('loading')
					
					const sendOnce = submitButton.classList.contains('send-once')
					
					if(sendOnce) {
						submitButton.innerText = 'Enviado'
					} else {
						submitButton.removeAttribute('disabled', true)
					}
				}
			})
		})
	}
	
	let updateSentTime = function(form) {
		if(!form) return
		
		const sentTimeHiddenField = form.querySelectorAll('input[name="sent_time"]')
		
		if(sentTimeHiddenField) {
			sentTimeHiddenField.forEach(field => {
				const now = new Date()
				
				const dateOptions = {
					weekday: 'long',
					day: '2-digit',
					month: 'long',
					year: 'numeric'
				}
				
				const formattedDate = now.toLocaleDateString('pt-BR', dateOptions)
				
				const timeOptions = {
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit',
					hour12: false
				}
				
				const formattedTime = now.toLocaleTimeString('pt-BR', timeOptions);
				
				const sentTime = `${formattedDate} ${formattedTime}`;
				
				field.value = sentTime
			})
		}
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
    // Mask document input
    let documentInputs = document.querySelectorAll('.cpf')
    
    if(documentInputs) {
    	documentInputs.forEach(input => {
    		$(input).mask('000.000.000-00', {reverse: true});
    	})
    }
    
    // Mask CEP input
    let cepInputs = document.querySelectorAll('.cep')
    
    if(cepInputs) {
    	cepInputs.forEach(input => {
    		$(input).mask('00000-000');
    	})
    }
    
	// Mask CPF / CNPJ input
	let documentOptions = {
		onKeyPress : function(cpfcnpj, e, field, options) {
			var masks = ['000.000.000-000', '00.000.000/0000-00'];
			var mask = (cpfcnpj.length > 14) ? masks[1] : masks[0];
			$('.cpf_cnpj').mask(mask, options);
		}
	};

	$('.cpf_cnpj').mask('000.000.000-000', documentOptions);
	
	// Campos condicionais devem ser <label> contendo os campos
	const conditionalFields = document.querySelectorAll('.conditional-field')
	
	if(conditionalFields) {
		conditionalFields.forEach(fieldContainer => {
			const relatedFieldName = fieldContainer.dataset.relatedFieldName
			const expectedValue = fieldContainer.dataset.expectedValue
			
			const relatedField = document.querySelector(`[name=${relatedFieldName}]`)
			
			if(!relatedField) {
				console.warn('No field related to selected conditional field', fieldContainer)
				return
			}
			
			const validateField = () => {
				const currentValue = relatedField.value
				const field = fieldContainer.querySelector('input, textarea, select')
				
				if(!field) {
					console.warn('No field found inside conditionalFields container')
					return
				}
				
				if(currentValue === expectedValue) {
					fieldContainer.style.display = 'block'
					field.setAttribute('required', true)
				} else {
					fieldContainer.style.display = 'none'
					field.removeAttribute('required')
				}
			}
			
			validateField()
			relatedField.addEventListener('change', () => validateField())
		})
	}

    
})(jQuery);